import { Duration, parseDuration, serializeDuration } from 'modules/std/time'
import {
  SerializersWithDefaultFactory,
  useQueryStates
} from 'next-usequerystate'
import { IntervalQuery } from './defs'

export function useIntervalQuery({ from, duration }: IntervalQuery) {
  return useQueryStates({
    from: fromSerializer.withDefault(from),
    duration: durationSerializer.withDefault(duration)
  })
}

// Internal - Exported for tests --

export const fromSerializer: SerializersWithDefaultFactory<number> = {
  parse: (query: string) => {
    try {
      const timestamp = new Date(parseInt(query) * 1000).valueOf()
      if (!Number.isSafeInteger(timestamp)) {
        return null
      }
      return timestamp
    } catch {
      return null
    }
  },
  serialize: timestamp => {
    return Math.floor(timestamp / 1000).toFixed()
  },
  withDefault(defaultValue) {
    return {
      ...this,
      defaultValue
    }
  }
}

export const durationSerializer: SerializersWithDefaultFactory<Duration> = {
  parse: parseDuration,
  serialize: serializeDuration,
  withDefault(defaultValue) {
    return {
      ...this,
      defaultValue
    }
  }
}
